'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import ThemeCommandBar from 'DesignFinderUI/components/commandbar/ThemeCommandBar';
import ProjectCommandBar from 'DesignFinderUI/components/commandbar/ProjectCommandBar';
export default function CommandBar(props) {
  // Intially this returned an array of bars.
  // If we need multiple again in future return them as an array
  // and let them determine if they render or not.
  return [/*#__PURE__*/_jsx(ThemeCommandBar, Object.assign({}, props), 'theme-command-bar'), /*#__PURE__*/_jsx(ProjectCommandBar, Object.assign({}, props), 'project-command-bar')];
}